import { withTrackedReducer } from '@angular-architects/ngrx-toolkit';
import { CrewDashboardState } from '@navstation-portal/reporting/data-model/crew-dashboard';
import { signalStoreFeature } from '@ngrx/signals';
import { on } from '@ngrx/signals/events';
import { crewDashboardEvents } from './crew-dashboard-events';

export function withCrewDashboardReducer() {
  return signalStoreFeature(
    withTrackedReducer(
      on(
        crewDashboardEvents.fetchDashboardData,
        (): Partial<CrewDashboardState> => ({
          isLoading: true,
          error: undefined,
        })
      ),
      on(crewDashboardEvents.fetchDashboardDataSuccess, ({ payload }): Partial<CrewDashboardState> => {
        return {
          isLoading: false,
          error: undefined,
          dashboardData: payload,
        };
      }),
      on(
        crewDashboardEvents.fetchDashboardDataFailed,
        ({ payload }): Partial<CrewDashboardState> => ({
          isLoading: false,
          error: payload,
        })
      ),
      on(crewDashboardEvents.selectRange, ({ payload }): Partial<CrewDashboardState> => {
        return {
          selectedRange: payload,
        };
      })
    )
  );
}
